export {default} from './login.vue'